import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CollectionTypeToggleModule } from '@shared/core/components/collectionTypeToggle';
import { HeadersModule } from '@shared/core/components/headers';
import { ProjectionModule } from '@shared/core/components/projection';
import { SearchFormModule } from '../../searchForm';
import { SearchForLocationsHeroComponent } from './search-for-locations-hero.shared.component';

@NgModule({
    declarations: [
        SearchForLocationsHeroComponent,
    ],
    imports: [
        CommonModule,
        CollectionTypeToggleModule,
        HeadersModule,
        SearchFormModule,
        ProjectionModule,
    ],
    exports: [
        SearchForLocationsHeroComponent
    ],
})
export class SearchForLocationsHeroModule { }
